<template>
  <div class="login-container">
    <div class="login-wrapper">
      <div class="login-card">
        <!-- 顶部 Logo 区域 -->
        <div class="brand-header">
          <div class="logo-icon" :class="{ 'logo-icon--custom': !!gymLogo }">
            <img v-if="gymLogo" :src="gymLogo" alt="" class="brand-logo-img" />
            <svg v-else viewBox="0 0 24 24" width="36" height="36" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round">
              <path d="M18 20V10"></path>
              <path d="M12 20V4"></path>
              <path d="M6 20v-6"></path>
            </svg>
          </div>
          <h2 class="brand-title">{{ gymName }}</h2>
        </div>

        <div class="tabs-header">
          <div class="tab-item" :class="{ active: activeTab === 'login' }" @click="activeTab = 'login'">密码登录</div>
          <div class="tab-item" :class="{ active: activeTab === 'phone' }" @click="activeTab = 'phone'">手机注册</div>
        </div>

        <!-- 登录表单 -->
        <div v-show="activeTab === 'login'" class="form-content">
          <el-form ref="loginFormRef" :model="loginForm" :rules="loginRules" class="auth-form">
            <el-form-item prop="username">
              <el-input
                v-model="loginForm.username"
                placeholder="请输入登录用户名"
                :prefix-icon="UserIcon"
                size="large"
                clearable
              />
            </el-form-item>

            <el-form-item prop="password">
              <el-input
                v-model="loginForm.password"
                type="password"
                placeholder="请输入登录密码"
                :prefix-icon="LockIcon"
                size="large"
                show-password
              />
            </el-form-item>

            <el-button type="primary" size="large" class="btn-submit" :loading="isLoading" @click="handleLogin">
              登 录
            </el-button>
          </el-form>
        </div>

        <!-- 手机注册表单 -->
        <div v-show="activeTab === 'phone'" class="form-content">
          <el-form ref="phoneRegisterFormRef" :model="phoneRegisterForm" :rules="phoneRegisterRules" class="auth-form">
            <el-form-item prop="phone">
              <el-input v-model="phoneRegisterForm.phone" placeholder="请输入手机号码" :prefix-icon="IphoneIcon" size="large" clearable />
            </el-form-item>

            <el-form-item prop="code">
              <div class="code-input-wrapper">
                <el-input v-model="phoneRegisterForm.code" placeholder="短信验证码" :prefix-icon="MessageIcon" size="large" clearable />
                <el-button class="code-btn" size="large" :disabled="countdown > 0" @click="sendSmsCode">
                  {{ countdown > 0 ? `${countdown}s 后重试` : '获取验证码' }}
                </el-button>
              </div>
            </el-form-item>

            <el-form-item prop="password">
              <el-input v-model="phoneRegisterForm.password" type="password" placeholder="设置登录密码" :prefix-icon="LockIcon" size="large" show-password />
            </el-form-item>

            <el-button type="primary" size="large" class="btn-submit" :loading="isRegistering" @click="handlePhoneRegister">
              注 册
            </el-button>
          </el-form>
        </div>
      </div>
      
      <div class="footer-copy">
        © {{ year }} {{ footerBrand }}. All rights reserved.
      </div>
    </div>
  </div>
</template>

<script>
import { User, Lock, Iphone, Message } from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'
import api from '@/api/request'

export default {
  name: 'login',
  data() {
    return {
      UserIcon: User,
      LockIcon: Lock,
      IphoneIcon: Iphone,
      MessageIcon: Message,
      activeTab: 'login',
      countdown: 0,
      timer: null,

      loginForm: {
        username: '',
        password: ''
      },
      loginRules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      isLoading: false,

      isRegistering: false,
      phoneRegisterForm: {
        phone: '',
        code: '',
        password: ''
      },
      phoneRegisterRules: {
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请设置密码', trigger: 'blur' },
          { min: 6, message: '密码至少 6 位', trigger: 'blur' }
        ]
      }
    };
  },
  beforeUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  computed: {
    gymName() {
      return this.$store.getters.gymName;
    },
    gymLogo() {
      return this.$store.getters.gymLogo;
    },
    year() {
      return new Date().getFullYear();
    },
    footerBrand() {
      const n = this.gymName || '';
      return n.length > 24 ? n.slice(0, 24) + '…' : n || 'GYM';
    },
  },
  mounted() {
    this.$store.dispatch('fetchBranding');
  },
  methods: {
    handleLogin() {
      this.$refs.loginFormRef.validate(async (valid) => {
        if (!valid) return;
        this.isLoading = true;
        try {
          const res = await api.login(this.loginForm.username, this.loginForm.password);
          if (res.data && res.data.code === 200) {
            const data = res.data.data || {};
            const userData = {
              username: data.username || this.loginForm.username,
              role: data.userType || data.role || 'admin',
              token: data.token || `mock_token_${Date.now()}`,
              avatar: data.avatar || '',
              memberId: data.memberId,
              typeId: data.typeId,
            };
            this.$store.dispatch('login', userData);
            ElMessage.success('登录成功');
            const redirect = this.$route.query.redirect || '/';
            this.$router.push(redirect);
          } else {
            ElMessage.error(res.data?.message || res.data?.msg || '用户名或密码错误');
          }
        } catch (e) {
          ElMessage.error('登录失败，请检查网络或账户信息');
        } finally {
          this.isLoading = false;
        }
      });
    },

    async sendSmsCode() {
      if (!/^1[3-9]\d{9}$/.test(this.phoneRegisterForm.phone)) {
        return ElMessage.warning('请先输入正确的手机号码');
      }
      try {
        const res = await api.sendSmsCode(this.phoneRegisterForm.phone);
        if (res.data && res.data.code === 200) {
          ElMessage.success('验证码发送成功');
          this.countdown = 60;
          this.timer = setInterval(() => {
            this.countdown--;
            if (this.countdown <= 0) {
              clearInterval(this.timer);
            }
          }, 1000);
        } else {
          ElMessage.error(res.data?.message || '发送失败');
        }
      } catch (e) {
        ElMessage.error('发送验证码请求失败');
      }
    },

    handlePhoneRegister() {
      this.$refs.phoneRegisterFormRef.validate(async (valid) => {
        if (!valid) return;
        this.isRegistering = true;
        try {
          const res = await api.smsRegister({
            phone: this.phoneRegisterForm.phone,
            code: this.phoneRegisterForm.code,
            password: this.phoneRegisterForm.password
          });
          if (res.data && res.data.code === 200) {
            const data = res.data.data || {};
            if (data.token) {
              const userData = {
                username: data.username || this.phoneRegisterForm.phone,
                role: data.userType || 'member',
                token: data.token,
                avatar: data.avatar || '',
                memberId: data.memberId,
                typeId: data.typeId,
              };
              this.$store.dispatch('login', userData);
              ElMessage.success('注册成功');
              const redirect = this.$route.query.redirect || '/';
              this.$router.push(redirect);
            } else {
              ElMessage.success('注册成功，请登录');
              this.activeTab = 'login';
              this.loginForm.username = this.phoneRegisterForm.phone;
              this.loginForm.password = '';
            }
          } else {
            ElMessage.error(res.data?.message || res.data?.msg || '注册失败');
          }
        } catch (e) {
          ElMessage.error('注册失败，请稍后重试');
        } finally {
          this.isRegistering = false;
        }
      });
    }
  }
};
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, #E8F4FD 0%, #FFFFFF 100%);
  padding: 20px;
}

.login-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 420px;
}

.login-card {
  width: 100%;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  padding: 40px;
  box-sizing: border-box;
}

.brand-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 24px;
}

.logo-icon {
  color: #0062FF;
  margin-bottom: 12px;
  width: 56px;
  height: 56px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, rgba(0, 98, 255, 0.12), rgba(0, 98, 255, 0.04));
}

.logo-icon--custom {
  background: #fff;
  border: 1px solid #E5E7EB;
  box-sizing: border-box;
}

.brand-logo-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.brand-title {
  font-size: 20px;
  font-weight: 600;
  color: #1F2937;
  margin: 0;
  letter-spacing: 0.5px;
}

.tabs-header {
  display: flex;
  justify-content: center;
  gap: 24px;
  margin-bottom: 24px;
  border-bottom: 1px solid #E5E7EB;
}

.tab-item {
  padding: 10px 4px;
  font-size: 15px;
  color: #6B7280;
  cursor: pointer;
  position: relative;
  transition: all 0.3s;
}

.tab-item:hover {
  color: #1F2937;
}

.tab-item.active {
  color: #0062FF;
  font-weight: 600;
}

.tab-item.active::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 100%;
  height: 2px;
  background: #0062FF;
  border-radius: 2px;
}

.form-content {
  width: 100%;
}

.auth-form :deep(.el-input__wrapper) {
  background: #F9FAFB;
  border: 1px solid #E5E7EB;
  border-radius: 6px;
  box-shadow: none !important;
  height: 48px;
  padding: 0 12px;
}

.auth-form :deep(.el-input__wrapper.is-focus) {
  border-color: #0062FF;
  background: #ffffff;
}

.auth-form :deep(.el-input__inner) {
  font-size: 14px;
  color: #1F2937;
}

.auth-form :deep(.el-input__prefix-inner) {
  font-size: 18px;
  color: #9CA3AF;
  margin-right: 4px;
}

.code-input-wrapper {
  display: flex;
  gap: 12px;
}

.code-input-wrapper :deep(.el-input) {
  flex: 1;
}

.code-btn {
  width: 110px;
  height: 48px;
  border: 1px solid #E5E7EB;
  background: #F9FAFB;
  color: #4B5563;
  font-size: 14px;
}

.code-btn:not(:disabled):hover {
  border-color: #0062FF;
  color: #0062FF;
  background: #ffffff;
}

.btn-submit {
  width: 100%;
  height: 48px;
  font-size: 16px;
  font-weight: 600;
  background: #0062FF;
  border: none;
  border-radius: 6px;
  margin-top: 12px;
  transition: all 0.3s;
}

.btn-submit:hover {
  background: #0052D9;
  transform: translateY(-1px);
}

.footer-copy {
  margin-top: 24px;
  font-size: 12px;
  color: #9CA3AF;
  text-align: center;
}

@media (max-width: 480px) {
  .login-card {
    padding: 30px 20px;
  }
  
  .brand-title {
    font-size: 18px;
  }
}
</style>
